import * as $ from 'jquery';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { Routes, RouterModule } from '@angular/router';
import { TermsComponent } from './terms/terms.component';
import { InfoEfosComponent } from './info-efos/info-efos.component';

import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';
import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { RightSidebarComponent } from './shared/right-sidebar/rightsidebar.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';

import { AppRoutingModule } from './app-routing.module';

import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './shared/spinner.component';

import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import {TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ShowHidePasswordModule } from 'ngx-show-hide-password';
import { LocalizeRouterModule } from 'localize-router';
// import { routes } from './app-routing.module';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AuthService } from './authentication/login/auth.service';
import { GlobalService } from './global/global.service';
import { PolicyComponent } from './policy/policy.component';
import { CallbackComponent } from './callback/callback.component';
import { AllService } from './rest/all.service';
import { InterceptorService } from './interceptor/interceptor.service';
// import { ConnectionForeignComponent } from './connection-foreign/connection-foreign.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    TermsComponent,
    InfoEfosComponent,
    SpinnerComponent,
    FullComponent,
    PolicyComponent,
    BlankComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent,
    RightSidebarComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    CallbackComponent,
    // ConnectionForeignComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    HttpClientModule,
    ToastModule.forRoot(),
    ShowHidePasswordModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
      }
  }),
    HttpModule,
    AppRoutingModule,
    CommonModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    {
    provide: LocationStrategy,
    useClass: HashLocationStrategy,
    },
    AuthService,
    GlobalService,
    AllService
],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts